import { Tag as FoundationsTag } from 'foundations-components/transitional/components/Tag';
import { jsx as _jsx } from "react/jsx-runtime";
export const tagTypes = {
  DEFAULT: 'default',
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning'
};
function Tag(props) {
  const {
    children,
    type = tagTypes.DEFAULT
  } = props;
  return /*#__PURE__*/_jsx(FoundationsTag, {
    inline: true,
    use: type,
    children: children
  });
}
export default Tag;